const currencyRate = _ => {
    fetch("/cart/update.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            attributes: {
            '_rate': window.Shopify?.currency?.rate ?? 1
            },
        }),
    })
}

const getTotal = total => {
    return (total / 100) * window.Shopify.currency.rate
}
const verifyGifts = (items, total) => {
    const actualGifts = items.filter(({ id, properties }) => properties?._gam_gift && id == 37254413265)
    const numberOfActualGifts = actualGifts.reduce((sum, { quantity }) => sum + quantity, 0)
    const numberOfGifts = 1

    if (numberOfActualGifts > numberOfGifts || numberOfActualGifts == 1) {
        const toDelete = actualGifts.find(({ final_line_price }) => final_line_price != 0)
        console.log("to Delete?", toDelete?.id)
        if(toDelete?.id){
            liquidAjaxCart.change({ id: toDelete?.key, quantity: 0 })
        }
        /* liquidAjaxCart.change({id: 42675930202270 , quantity: numberOfGifts == 0 ? 0 : numberOfActualGifts - numberOfGifts}) */
    } else if (numberOfGifts > numberOfActualGifts && total >= 70) {
        console.log("to add")
        liquidAjaxCart.add({
            id: 37254413265,
            quantity: numberOfGifts - numberOfActualGifts,
            properties: {
                _gam_gift: true
            }
        })
    }

    /* console.log("adasdasdsad", numberOfGifts, numberOfActualGifts, numberOfGifts - numberOfActualGifts) */
}
document.addEventListener("liquid-ajax-cart:init", _ => {
    currencyRate()
    //verifyGifts(liquidAjaxCart.cart.items, getTotal(liquidAjaxCart.cart.total_price))
});
const toggleCart = (open = null) => {
    if(open === null){
        document.body.classList.toggle('js-show-ajax-cart')
    }else{
        if(open){
            document.body.classList.add('js-show-ajax-cart')
        }else{
            document.body.classList.remove('js-show-ajax-cart')
        }
    }
}

/* document.querySelectorAll("product-form").forEach(form => {
    form.addEventListener("addToCart", event => {
        console.log("adsadasdas")
        liquidAjaxCart.add({}, {
            lastCallback: _ => {
                const submitButtons = form.querySelectorAll('[type="submit"]');
                submitButtons.forEach((button) => {
                    button.classList.remove("loading");
                    button.removeAttribute('aria-disabled');
                })
                toggleCart(true)
            }
        });
    })
}) */
document.addEventListener('liquid-ajax-cart:request-end', event => {
  const {requestState} = event.detail;
  // verifyGifts(liquidAjaxCart.cart.items, getTotal(liquidAjaxCart.cart.total_price))
  // If the "add to cart" request is successful
  if (requestState.requestType === 'add' && requestState.responseData?.ok) {
    toggleCart(true)
  }
});